import { onUnmounted, ref } from 'vue';
export const useIntersectionObserver = () => {
    const observerRef = ref();
    // eslint-disable-next-line no-undef
    const createObserver = (options, callback) => {
        const opts = {
            ...{ rootMargin: '0px', threshold: 1.0 },
            ...options,
        };
        return new IntersectionObserver(callback, opts);
    };
    const getObserver = () => observerRef.value;
    const observe = (root, watch, 
    // eslint-disable-next-line no-undef
    callback, rootMargin = '0px', threshold = 1.0) => {
        const opts = {
            root: root,
            rootMargin: rootMargin,
            threshold: threshold,
        };
        const observer = createObserver(opts, callback);
        observerRef.value = observer;
        if (watch && !Array.isArray(watch)) {
            observer.observe(watch);
        }
        if (Array.isArray(watch)) {
            watch.forEach(el => observer.observe(el));
        }
    };
    const unobserve = (target) => {
        if (typeof observerRef?.value?.unobserve !== 'function')
            return;
        if (Array.isArray(target)) {
            target.forEach(el => observerRef.value?.unobserve(el));
        }
        else if (target) {
            observerRef.value.unobserve(target);
        }
    };
    const cleanup = () => {
        if (typeof observerRef?.value?.disconnect === 'function') {
            observerRef.value.disconnect();
        }
    };
    onUnmounted(() => cleanup());
    return {
        cleanup,
        getObserver,
        observe,
        unobserve,
    };
};
